<template>
  <div style="padding-bottom: 50px">
    <!-- 上部分 -->
    <!-- <div class="homeIndex">
      <el-row :gutter="30" style="width:100%;margin:20px 0px 0px 0px">
        <el-card shadow="always" style="width:96%;margin:0px auto">
          <template #header>
            <div class="card-header">
              <span class="title">{{name}}</span>
            </div>
          </template>
            <div class="spbh">
              <span>税盘编号：{{jqbh}}</span>
              <span @click="connect" style="cursor:pointer"><img src="@/assets/u.png" alt="" style="width:30px">连接税盘</span>
            </div>
            <el-descriptions title="">
              <el-descriptions-item label="主管税务机关：">{{zgswjg}}</el-descriptions-item>
              <el-descriptions-item label="开户日期：">{{khrq}}</el-descriptions-item>
              <el-descriptions-item label="企业税号：">{{qysh}}</el-descriptions-item>
              <el-descriptions-item label="税务机关代码：">{{swjgdm}}</el-descriptions-item>
              <el-descriptions-item label="机器编号：">{{jqbh}}</el-descriptions-item> -->
              <!-- <el-descriptions-item label="企业性质：">{{xzFilter(qyxz)}}</el-descriptions-item> -->
              <!-- <el-descriptions-item label="发票余量：">
                <el-tooltip effect="light" placement="right">
                  <template #content> 
                    <el-table :data="data" border size="mini">
                      <el-table-column align="center" prop="name" label="发票名称" min-width="150px"></el-table-column>
                      <el-table-column align="center" prop="value" label="剩余份数" min-width="150px"></el-table-column>
                    </el-table>  
                  </template>
                  <i class="el-icon-view" style="cursor:pointer;"></i>
                </el-tooltip>
              </el-descriptions-item>
            </el-descriptions>
        </el-card>
      </el-row>
    </div> -->
    <!-- 下部分echarts -->
    <!-- <div class="padding-bottom: 50px;margin-bottom:50px">
      <el-row :gutter="100" type="flex" align="middle" style="margin: 20px 0px 0px 0px">
        <el-col :span="11">
          <el-card shadow="always">
            <template #header>
              <div class="card-header">
                <span class="title">月度开票汇总</span>
              </div>
            </template>
            <MonthInvoice ref="monthInvoice" @success="initMonth" :list="list"></MonthInvoice>
          </el-card>
        </el-col>
        <el-col :span="11">
          <el-card shadow="always">
            <template #header>
              <div class="card-header">
                <span class="title">季度开票汇总</span>
              </div>
            </template>
            <JdInvoice ref="jdInvoice" @success="initJd" :list="list2"></JdInvoice>
          </el-card>
        </el-col>
      </el-row>
    </div> -->
    <div>
      <div style="text-align:center"><img src="@/assets/dashbord.png" alt="" srcset=""></div>
      <div class="noDate">暂无内容...</div>
    </div>
  </div>
</template>

<script>
import MonthInvoice from "./components/monthInvoice.vue";
import JdInvoice from "./components/jdInvoice.vue";
import { indexInvoice, invoiceStatus } from "@/api/homeIndex";
import { defineComponent  } from 'vue'
export default defineComponent({
  components:{ MonthInvoice, JdInvoice },
  name: "homeIndex",
  data(){
    return {
      title: '',
      list:[],
      list2:[],
      list3:[],
      data:[],//发票余量
    }
  },
  mounted(){
  },
  setup() {

  },
  created(){
    // this.getList()
  },
  computed: {

    // name(){
    //   this.getList()
    //   return this.$store.getters['user/comInfo'].name
    // },
    // zgswjg(){return this.$store.getters['user/comInfo'].swjgmc},
    // khrq(){return this.$store.getters['user/comInfo'].qysj},
    // fwqx(){return this.$store.getters['user/comInfo'].swjgmc},
    // qysh(){return this.$store.getters['user/comInfo'].tax_no},
    // swjgdm(){return this.$store.getters['user/comInfo'].swjgdm},
    // qyxz(){return this.$store.getters['user/comInfo'].qylx},
    // jqbh(){return this.$store.getters['user/comInfo'].jqbh},
  },
  data(){
    return {
      listQuery:{
        comId:this.$store.getters['user/comInfo'].id,
        jd:this.$store.getters.currQuarter,
        month:this.$store.getters.currMonth
      }
    }
  },
  methods:{
    xzFilter(n){
       if(n == "00"){
         return "非特殊企业"
       }else if(n == "01"){
         return "特殊企业"
       }else if(n == "05"){
         return "转登记纳税人"
       }else if(n == "08"){
         return "小规模纳税人"
       }
    },
    //初始化视图
    initMonth(e){
      this.listQuery.month = e
      this.getList()
    },
    initJd(e){
      this.listQuery.jd = e
      this.getList()
    },
    getList(){
      this.listQuery.comId = this.$store.getters['user/comInfo'].id
      indexInvoice(this.listQuery).then(res=>{
        this.list = res.data.data.info.monthSum
        this.list2 = res.data.data.info.jdSum
        this.list3 = res.data.data.info.ypList
        this.data =  this.list3.map(v=>{
          return {
            name:this.$fplx(v.fplxdm),
            value:v.syfs}
        })
        console.log(this.data);
        this.$refs.monthInvoice.init(this.list)
        this.$refs.jdInvoice.init(this.list2)
      })
    },
    connect(){
      invoiceStatus({comId:this.$store.getters['user/comInfo'].id}).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("连接正常")
        }
      })
    },
  }
})
</script>

<style lang="scss">
  .card-header {
    height: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .box-card {
    width: 30%;
  }
  .title{
    font-size: 16px;
    font-weight: 600;
  }
  .spbh{
    color: #6ABFBA;
    position: relative;
    float: right;
    top: -60px;
    span{
      margin-right: 10px; 
      margin-left: 10px;
      img{
        position: relative;
        top:7px
      }
    }
  }
  .noDate{
    text-align: center;
    font-size: 31px;
    font-weight: 500;
    color: #1482f0;
    margin-top: -104px;
  }
</style>
<style>
.el-descriptions__label:not(.is-bordered-label){
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}
.el-descriptions__title {
  font-size: 18px;
}
i:hover{
  color: #6ABFBA;
}
.has-gutter{
  color: #fff !important;
}
</style>